<template>
  <el-card :style="{'min-height': boxMinHeight}">
    <div slot="header">
      <span class="header-class">{{ dataHeader }}</span>
    </div>
    <div>
      <el-checkbox-group v-model="content" v-on:change="dataHandler">
        <div v-for="(data,index) in dataList" :key="index">
          <el-checkbox v-if="dataNotation === 'gz' && (availableUnit.includes(correctThrust(data.name)) || role)" :class="getGZCheckBoxClass()" :label="data.name">
            <div class="checkbox-class">
              <p class="checkbox-label">{{(noPrefix(data.name) ? "" : thrustPrefix) + correctThrust(data.name, true)+' ('+getAbbreviation(correctThrust(data.name))+')'}}</p>
            </div>
          </el-checkbox>
          <el-checkbox v-if="dataNotation === 'gz' && !availableUnit.includes(correctThrust(data.name)) && !role" disabled :class="getGZCheckBoxClass()" :label="data.name">
            <div class="checkbox-class">
              <p class="checkbox-label">{{(noPrefix(data.name) ? "" : thrustPrefix) + correctThrust(data.name, true)+' ('+getAbbreviation(correctThrust(data.name))+')'}}</p>
            </div>
          </el-checkbox>
          <el-checkbox v-if="dataNotation === 'hk' && (availableUnit.includes(correctThrust(data.name)) || role)" :class="getCWBCheckBoxClass()" :label="data.name">
            <div class="checkbox-class">
              <p class="checkbox-label">{{(noPrefix(data.name) ? "" : thrustPrefix) + correctThrust(data.name, true)+' ('+getAbbreviation(correctThrust(data.name))+')'}}</p>
            </div>
          </el-checkbox>
          <el-checkbox v-if="dataNotation === 'hk' && !availableUnit.includes(correctThrust(data.name)) && !role" disabled :class="getCWBCheckBoxClass()" :label="data.name">
            <div class="checkbox-class">
              <p class="checkbox-label">{{(noPrefix(data.name) ? "" : thrustPrefix) + correctThrust(data.name, true)+' ('+getAbbreviation(correctThrust(data.name))+')'}}</p>
            </div>
          </el-checkbox>
        </div>
      </el-checkbox-group>
    </div>
  </el-card>
</template>

<script>

import thrustCorrectionMixin from "@/components/view/js/thrustCorrectionMixin";
import screeningAbbreviationMixin from "@/components/view/js/screeningAbbreviationMixin";

export default {
  comments:{
  },
  name: "DepartmentViewingComponent",
  mixins: [thrustCorrectionMixin, screeningAbbreviationMixin],
  props: {
    thrustPrefix: {
      type: String,
      default: ''
    },
    dataList: {
      type: Array,
      default: () => []
    },
    dataHeader:{
      type: String,
      default: ''
    },
    dataNotation:{
      type: String,
      default: ''
    },
    content:{
      type: Array,
      default: () => []
    },
    availableUnit:{
      type: Array,
      default: () => []
    },
    role:{
      type: Boolean,
      default: true
    },
    greenCheckBox:{
      type: Boolean,
      default: false
    },
    boxMinHeight: {
      type: String,
      default: '0px'
    }
  },
  methods: {
    getGZCheckBoxClass(){
      if(this.greenCheckBox){
        return "green-checkbox"
      }
      else{
        return "gold-checkbox"
      }
    },
    getCWBCheckBoxClass(){
      if(this.greenCheckBox){
        return "green-checkbox"
      }
      else{
        return ""
      }
    },
    dataHandler(){
      this.$emit('departmentDataUpdate',this.content,this.dataNotation)
    },
    // getAbbreviation(thrustName){
    //   if(thrustAbbreviationjson.hasOwnProperty(thrustName)){
    //     return thrustAbbreviationjson[thrustName]
    //   }
    //   else{
    //     return thrustName
    //   }
    // },
  }
}
</script>

<style scoped>
@import "../components/view/css/customCheckBox.css";
</style>
